import { useScheduleOnline } from '../../../../../../contexts/SchedulerOnlineContext';
import { useToastValue } from '../../../../../../contexts/toastMessage';
import { UserData } from '../../../../../../interfaces/user';
import {
  anexarArquivo,
  atenderOnline,
  incluirDependente,
  salvarMotivosTopicos,
} from '../../../../../../services/atendimentos';
import { SavedScheduleProps } from '../../../../../../types/scheduling';
import { removeCpfMask, validateCpf } from '../../../../../../utils/cpfFormat';
import getCookie from '../../../../../../utils/getCookies';
import { validateAndReturnResponse, handleApiError } from '../../../../../../utils/apiValidation';

export const useActions = () => {
  const { setToast } = useToastValue();
  const {
    formDataReason,
    serviceData,
    files,
    setIsAttachmentRequired,
    cpfDependente,
    nameDependente,
    setErrorNameDependente,
    setErrorCpfDependente,
    birthDateDependente,
    grauDependenteSelected,
    unitySelected,
    selectedDate,
    scheduleSelected,
    setScheduleServiceUser,
    setScheduleService,
    setLoading,
    typeSchedule,
    setSavedSchedule,
  } = useScheduleOnline();

  const handleSubmitMotivos = async (savedSchedule: any) => {
    const token: string | null = getCookie('gov_access_token_sso');
    try {
      const response = await salvarMotivosTopicos(
        token,
        savedSchedule.id.toString(),
        formDataReason.descriptionProblem,
        formDataReason.reasonService,
      );

      validateAndReturnResponse(response);
    } catch (error) {
      const errorMessage = handleApiError(error as any);

      setToast({
        visible: true,
        type: 'error',
        message: errorMessage,
      });

      throw error;
    }
  };

  const handleUploads = async (savedSchedule: any) => {
    if (serviceData?.configuracao_agendamento?.anexo && files?.length === 0) {
      setIsAttachmentRequired(true);
      return;
    }

    const token: string | null = getCookie('gov_access_token_sso');

    if (savedSchedule && files.length >= 1) {
      try {
        // eslint-disable-next-line no-restricted-syntax
        for (const fileUpload of files) {
          const response = await anexarArquivo(
            token,
            fileUpload.file.name,
            fileUpload.file.type,
            fileUpload.file,
            savedSchedule.id.toString(),
          );

          validateAndReturnResponse(response);
        }
      } catch (error) {
        const errorMessage = handleApiError(error as any);

        setToast({
          visible: true,
          type: 'error',
          message: errorMessage,
        });

        throw error;
      }
    }
  };

  const handleDependente = async (savedSchedule: any) => {
    const token: string | null = getCookie('gov_access_token_sso');
    const dataStorage: string | null = getCookie('gov_user_data');
    const userData: UserData | null = dataStorage
      ? JSON.parse(dataStorage)
      : null;
    const cpfDependenteWithoutMask = removeCpfMask(cpfDependente);

    if (nameDependente && nameDependente.length < 6) {
      setErrorNameDependente('Nome deve ter no mínimo 6 caracteres.');
      return;
    }

    if (cpfDependenteWithoutMask) {
      if (
        !validateCpf(cpfDependenteWithoutMask) ||
        cpfDependenteWithoutMask.length < 11
      ) {
        setErrorCpfDependente('CPF inválido.');
      }
    }

    if (savedSchedule.para_dependente) {
      try {
        const response = await incluirDependente(
          savedSchedule.id,
          cpfDependenteWithoutMask,
          nameDependente,
          birthDateDependente,
          userData.cpf,
          grauDependenteSelected,
          token,
        );

        validateAndReturnResponse(response);
      } catch (error) {
        const errorMessage = handleApiError(error as any);

        setToast({
          visible: true,
          type: 'error',
          message: errorMessage,
        });

        throw error;
      }
    }
  };

  const schedulerService = async (): Promise<SavedScheduleProps> => {
    const token: string | null = getCookie('gov_access_token_sso');
    const dataStorage: string | null = getCookie('gov_user_data');
    const userData: UserData | null = dataStorage
      ? JSON.parse(dataStorage)
      : null;
    if (token && userData) {
      try {
        const response = await atenderOnline(
          token,
          serviceData.id,
          unitySelected,
          serviceData.titulo,
          `Agendamento para ${serviceData.titulo}`,
          serviceData.setor_id,
          'Video',
          selectedDate,
          scheduleSelected,
          typeSchedule === 'me' ? false : true,
        );

        validateAndReturnResponse(response);
        setScheduleServiceUser(response.data);

        return response.data;
      } catch (err) {
        const errorMessage = handleApiError(err as any);

        setToast({
          visible: true,
          type: 'error',
          message: errorMessage,
        });

        if (err.response?.data?.message) {
          setScheduleServiceUser(err.response.data.message);
        } else if (err.response?.data?.[0]) {
          setScheduleService(err.response?.data?.[0]);
        } else {
          setScheduleService('Algo inesperado ocorreu.');
        }

        throw err;
      }
    }

    throw new Error('Token ou dados do usuário não encontrados.');
  };

  const executeFlow = async () => {
    try {
      setLoading(true);
      const saveResult = await schedulerService();

      if (saveResult) {
        await handleDependente(saveResult);
        await handleUploads(saveResult);
        await handleSubmitMotivos(saveResult);

        setSavedSchedule(saveResult);
      }
    } catch (error) {
      // Erro já foi tratado nas funções individuais com toast
    } finally {
      setLoading(false);
    }
  };

  return {
    executeFlow,
  };
};